module.exports = __webpack_public_path__ + "static/media/firetruck.91958ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/project/firetruck.png
// module id = 473
// module chunks = 0